import { inject, Injectable, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, map, takeUntil } from 'rxjs/operators';
import { SharedLanguageService } from './shared-language.service';

@Injectable({ providedIn: 'root' })
export class UrlLanguageLoaderService implements OnDestroy {
    private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);
    private readonly sharedLanguageService: SharedLanguageService = inject(SharedLanguageService);

    private readonly destroy$ = new Subject<void>();

    constructor() {
        this.initLangParamListener();
    }

    private initLangParamListener(): void {
        this.activatedRoute.queryParamMap
            .pipe(
                takeUntil(this.destroy$),
                map((params: ParamMap) => params.get('lang') as string),
                filter(langParam => !!langParam),
                distinctUntilChanged()
            )
            .subscribe((langParam: string) => {
                this.sharedLanguageService.changeLocale(langParam);
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
